// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__fgfoE","head":"ProcedureTableInfo_head__bs1_9"};